<div class="chatbot-container" cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragBoundary=".cdk-overlay-container">
  <div class="chatbot-header" cdkDragHandle>
    <div class="header-icons">
      <div class="left-header-section">
        <!-- <img src="assets/images/mondelez-chat-icon-white.svg" /> -->
        <img src="assets/images/chat_icons/ai-icon-white.svg" alt="mondelezchaticon" />
        AI Chat Box
      </div>
      <div class="right-header-icon">
        <img src="assets/images/chat_icons/new-chat.svg" class="header-icon" alt="new-chat" title="Open New Chat" (click)="openNewChat()" />
        <img
          [src]="isMinimized ? 'assets/images/chat_icons/minimize.svg' : 'assets/images/chat_icons/maximize.svg'"
          class="header-icon"
          alt="maximize"
          (click)="toggleSize(); autoGrow(msgInput)"
        />

        <i class="pi pi-angle-down text-white header-icon" (click)="onClose()"></i>
      </div>
    </div>
  </div>
  <div class="chatbot-body" #chatContainer [ngClass]="{ 'messg-padding': isMinimized }">
    <div *ngIf="!welcomeScreen" class="chat-wrapper">
      <div class="message-container" *ngFor="let message of data.messages; let i = index">
        <!-- Sender Message - GenAI Message -->
        <div class="message sender-message" *ngIf="message.sender == 'other'">
          <div class="sendr-msg-text" #markdownContainer>
            <markdown [data]="message.text" (ready)="onMarkdownReady(markdownContainer, i)"> </markdown>
            <div *ngIf="message.additionalInfo && message.additionalInfo.length > 0">
              <div class="flex">
                <b class="cursor-pointer underline" (click)="message.additionalInfoExpanded = !message.additionalInfoExpanded">Addition Info</b>
              </div>
              <markdown *ngIf="message.additionalInfoExpanded" [data]="message.additionalInfo" (ready)="onMarkdownReady(markdownContainer, i)"> </markdown>
            </div>
            <div class="border my-2.5"></div>
            <div *ngIf="message.tableData && message.tableData.length > 0">
              <div class="flex">
                <b class="cursor-pointer" *ngIf="!message.tableExpanded" (click)="expandTable(i)"> Click to view the table. </b>
                <i class="pi pi-times pb-4 ml-auto cursor-pointer" title="close table" *ngIf="message.tableExpanded" (click)="message.tableExpanded = false"></i>
              </div>

              <table *ngIf="message.tableExpanded">
                <thead>
                  <tr>
                    <th *ngFor="let column of message.columns" (click)="sortData(i, column)" class="sortable">
                      {{ column }}
                      <span>{{ getSortIcon(message, column) }}</span>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let row of message.tableData">
                    <td *ngFor="let column of message.columns">{{ row[column] || '-' }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div class="sendr-msg-icon">
            <img src="assets/images/chat_icons/copy.svg" alt="copy" title="Copy" (click)="onCopy(i, 'other')" />

            <i
              class="pi pi-thumbs-up"
              alt="like"
              (click)="onLikeDislike(message, true, i)"
              title="Like"
              [ngClass]="{ 'pi-thumbs-up': message.user_liked === null || message.user_liked == false, 'pi-thumbs-up-fill': message.user_liked }"
            ></i>

            <i
              class="pi pi-thumbs-down"
              alt="dislike"
              (click)="onLikeDislike(message, false, i)"
              title="Dislike"
              [ngClass]="{ 'pi-thumbs-down': message.user_liked === null || message.user_liked == true, 'pi-thumbs-down-fill': !message.user_liked }"
            ></i>

            <span *ngIf="showCopyToClipboardMessage && copiedTextIndex == i" class="clipboard-copy-text">Copied</span>
          </div>

          <div class="profile-icon bot-icon" *ngIf="isMinimized">
            <!-- <img src="assets/images/mondelez-chat-icon.svg" alt="mondelezchaticon" /> -->
            <img src="assets/images/chat_icons/chatbot_icon.svg" alt="chatboticon" />
          </div>
        </div>

        <!-- User Message -->
        <div class="message receiver-message" *ngIf="message.sender == 'you'">
          <div class="rcvr-msg-text">
            <span>{{ message.text }}</span>
            <span *ngIf="message.image"> <img [src]="message.image" alt="close" /></span>
          </div>
          <div class="rcvr-msg-icon">
            <img src="assets/images/chat_icons/copy.svg" alt="copy" (click)="onCopy(i, 'you')" title="Copy" />
            <span *ngIf="showCopyToClipboardMessage && copiedTextIndex == i" class="clipboard-copy-text">Copied</span>
          </div>

          <div class="profile-icon user-icon" *ngIf="isMinimized">
            <img src="assets/images/chat_icons/user-icon.svg" />
          </div>
        </div>
      </div>
      <!-- Loader -->
      <div *ngIf="isTyping" class="loading-bar receiver-message" [ngClass]="{ 'fade-out': !isTyping, 'fade-in': isTyping }">
        <img src="assets/images/chat_icons/ai-icon-white.svg" />
      </div>
    </div>
    <div class="welcome-screen" *ngIf="welcomeScreen">
      <!-- <img class="mondelez-chat-logo" src="assets/images/chat_icons/mondelez-chat-logo.svg" alt="mondelez-chat-logo" /> -->
      <div class="freq-messages" (click)="showPreviousSession()">
        <img src="assets/images/chat_icons/history-icon.svg" alt="frequent question" />
        <p>{{ 'Continue Previous Session' | titlecase }}</p>
      </div>
      <ng-container *ngIf="visibleFreqMessage">
        <div *ngFor="let message of freqMessages" class="freq-messages" (click)="message?.runTask(message?.question)">
          <img [src]="message.image" alt="frequent question" />
          <p>{{ message.question | titlecase }}</p>
        </div>
      </ng-container>
    </div>
  </div>

  <div *ngIf="showScrollToBottom" class="scroll-to-bottom" (click)="scrollToBtmSmooth()">
    <img src="assets/images/chat_icons/scroll-to-btm.svg" alt="scroll-to-bottom" />
  </div>
  <div class="chatbot-footer">
    <div class="input-send" [ngClass]="{ 'input-width': isMinimized }">
      <textarea
        class="input-field"
        #msgInput
        placeholder="Ask me anything..."
        [(ngModel)]="userMessage"
        (keydown)="handleEnter($event)"
        rows="1"
        (input)="autoGrow(msgInput)"
        [disabled]="isTyping"
        [ngClass]="{ 'typing-background': isTyping }"
      ></textarea>
      <a class="send-box">
        <img *ngIf="!isTyping" src="assets/images/chat_icons/send-icon.svg" alt="new-chat" (click)="sendMessage()" />
        <img *ngIf="isTyping" src="assets/images/chat_icons/stop-icon.svg" alt="stop-chat" (click)="stopChat()" />
      </a>
    </div>
    <span class="btm-mssg">Responses may contain errors, verify before use.</span>
  </div>
</div>
